<template>
  <div class="drag-dialog-wrap">
    <el-dialog
      v-el-drag-dialog="canDrag"
      :close-on-click-modal="false"
      v-bind="$attrs"
      v-on="$listeners"
      :top="top"
      :style="'--height:' + height"
    >
      <slot name="title" slot="title"></slot>
      <slot></slot>
      <slot name="footer" slot="footer"></slot>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DragDialog',
  inheritAttrs: false,
  props: {
    height: {
      type: String,
      default: 'unset'
    },
    top: {
      type: String,
      default: '15vh'
    },
    canDrag: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.drag-dialog-wrap {
  .el-dialog__wrapper {
    display: flex;
    ::v-deep .el-dialog {
      margin-top: auto !important;
      margin: auto;
      height: var(--height);
      display: flex;
      flex-direction: column;
      .el-dialog__header {
        user-select: none;
        background: #283442;
        box-shadow: 0px 8px 16px 0px rgba(12, 0, 51, 0.1);
        // text-align: center;
        padding: 12px;
        min-height: 48px;
        .el-dialog__title {
          font-size: 20px;
          color: #fff;
        }
        .el-dialog__headerbtn {
          top: 5px;
          right: 5px;
          padding: 10px;
          i {
            color: #fff;
          }
        }
      }
      .el-dialog__body {
        overflow-y: auto;
        height: inherit;
        color: unset;
      }
      .el-dialog__footer {
        box-shadow: 0px -4px 16px 0px rgba(27, 35, 105, 0.08);
        padding: 16px 28px;
      }
    }
  }
}
</style>
